import { Job } from 'generated/apolloComponents'
import { useEffect, useState } from 'react'
import ApplicationButton from '../molecules/ApplicationButton'

interface iProps {
  job: Job
  setApplicationSuccess?: React.Dispatch<React.SetStateAction<boolean>>
  triggerComponentRef: React.RefObject<HTMLElement>
}

const JobApplyFooterMobile = ({
  job,
  setApplicationSuccess,
  triggerComponentRef,
}: iProps) => {
  const jobExpired: boolean = new Date(job.endsAt) < new Date()
  const [showFooterBasedOnScroll, setShowFooterBasedOnScroll] =
    useState<boolean>(false)

  useEffect(() => {
    // Define IntersectionObserver options
    // These could also be passed as props if more flexibility is needed in the future
    // eslint-disable-next-line no-undef
    const observerOptions: IntersectionObserverInit = {
      root: null, // observing intersections relative to the browser viewport
      rootMargin: '0px', // no margin around the root
      threshold: 0, // Callback runs as soon as 0% of the target is visible (i.e., it starts to exit or fully exits)
    }

    // Create the IntersectionObserver instance
    const observer = new IntersectionObserver(([entry]) => {
      setShowFooterBasedOnScroll(!entry.isIntersecting)
    }, observerOptions)

    const currentElement = triggerComponentRef.current

    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement)
      }
    }
  }, [triggerComponentRef, triggerComponentRef.current])

  if (jobExpired) {
    return null
  }

  return (
    <div
      className={`
        bg-gray-bg py-4 sticky bottom-0 left-0 right-0 z-1 md:hidden
        transform transition-all duration-300 ease-in-out
        ${
          showFooterBasedOnScroll
            ? 'translate-y-0 opacity-100'
            : 'translate-y-full opacity-0 pointer-events-none'
        }
      `}
    >
      <div className='container'>
        <div className='flex justify-between items-center gap-8 mx-8'>
          <ApplicationButton
            job={job}
            setApplicationSuccess={setApplicationSuccess}
            sidePanel
          />
        </div>
      </div>
    </div>
  )
}

export default JobApplyFooterMobile
